import { createContext, useContext } from "react";
import type { DirectoryResponse } from "@/client/ContentVaultApiClient/models";

interface PinnedDirectoriesContextType {
    pinnedDirectories: DirectoryResponse[];
    refreshPinnedDirectories: () => Promise<void>;
    isLoading: boolean;
}

export const PinnedDirectoriesContext = createContext<PinnedDirectoriesContextType | undefined>(undefined);

export function usePinnedDirectories() {
    const context = useContext(PinnedDirectoriesContext);
    if (context === undefined) {
        throw new Error("usePinnedDirectories must be used within a PinnedDirectoriesProvider");
    }
    return context;
}
